var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 35 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.76 16C28.07 16 30.76 13.31 30.76 10C30.76 6.69 28.07 4 24.76 4C21.45 4 18.76 6.69 18.76 10C18.76 13.31 21.45 16 24.76 16ZM24.76 6C26.97 6 28.76 7.79 28.76 10C28.76 12.21 26.97 14 24.76 14C22.55 14 20.76 12.21 20.76 10C20.76 7.79 22.55 6 24.76 6ZM24.76 13C26.41 13 27.76 11.65 27.76 10C27.76 8.35 26.41 7 24.76 7C23.11 7 21.76 8.35 21.76 10C21.76 11.65 23.11 13 24.76 13ZM24.76 9C25.31 9 25.76 9.45 25.76 10C25.76 10.55 25.31 11 24.76 11C24.21 11 23.76 10.55 23.76 10C23.76 9.45 24.21 9 24.76 9ZM10.76 16C14.07 16 16.76 13.31 16.76 10C16.76 6.69 14.07 4 10.76 4C7.45 4 4.76 6.69 4.76 10C4.76 13.31 7.45 16 10.76 16ZM10.76 6C12.97 6 14.76 7.79 14.76 10C14.76 12.21 12.97 14 10.76 14C8.55 14 6.76 12.21 6.76 10C6.76 7.79 8.55 6 10.76 6ZM10.76 13C12.41 13 13.76 11.65 13.76 10C13.76 8.35 12.41 7 10.76 7C9.11 7 7.76 8.35 7.76 10C7.76 11.65 9.11 13 10.76 13ZM10.76 9C11.31 9 11.76 9.45 11.76 10C11.76 10.55 11.31 11 10.76 11C10.21 11 9.76 10.55 9.76 10C9.76 9.45 10.21 9 10.76 9ZM34.04 0H0.72C0.32 0 0 0.45 0 1V19C0 19.55 0.32 20 0.72 20H34.03C34.43 20 34.75 19.55 34.75 19V1C34.75 0.45 34.43 0 34.03 0H34.04ZM32.76 18H1.86V2H32.76V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcaIcon);
export default __webpack_public_path__ + "static/media/rca-icon.4d717f3dd16e23c49de8707ebc46debc.svg";
export { ForwardRef as ReactComponent };